import {Link} from "react-router-dom";
import {Button, ButtonProps} from "flowbite-react";

export interface SelectableLinkProps {
    to: string;
    className: string;
    isSelected: boolean;
    children: React.ReactNode;
    hasBorder: boolean;
    title?: string;
}

export function SelectableLink(props: SelectableLinkProps) {
    return <Link
        to={props.to}
        title={props.title}
        className={`block px-2 py-1 border rounded-xl w-full ${props.hasBorder ? "border" : "border-none"} hover:border-neutral-500 hover:bg-gray-really  ${props.isSelected ? "border-neutral-500" : ""} ${props.className}`

    }
    >
        {props.children}
    </Link>
}

export type SelectableButtonProps = ButtonProps & {
    overrideClassName?: boolean;
    addBorder?: boolean;
}

export function SelectableButton(props: SelectableButtonProps) {
    const buttonProps = {...props};
    delete buttonProps.overrideClassName;
    delete buttonProps.addBorder;
    return <Button
        {...buttonProps}
        className={` ${props.overrideClassName === true ? "" : `block px-2 ${props.addBorder === true ? "border" : "border-none"} hover:border-neutral-500 hover:bg-gray-really rounded-xl w-full`} ${props.disabled === true ? "cursor-not-allowed opacity-50" : ""} ${props.className}`}
    >
        {props.children}
    </Button>
}